import dayjs from 'dayjs';
import { produce } from 'immer';
import Env from 'src/environmentVariables/EnvironmentVariables';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

export const getNextPointsDrop = () => {
	let nextPointsDrop = Env.driftPointsTestTimeMs
		? dayjs(Env.driftPointsTestTimeMs).utc() // mainly for testing
		: dayjs() // Friday 2pm UTC of the week
				.utc()
				.day(5)
				.hour(14)
				.minute(0)
				.second(0)
				.millisecond(0);

	nextPointsDrop = dayjs().isSameOrAfter(nextPointsDrop, 'seconds') // check if today is after Friday 2pm UTC of the week, if it is then set nextPointsDrop to next Friday
		? nextPointsDrop.add(1, 'week')
		: nextPointsDrop;

	return nextPointsDrop;
};

export interface PointsStore {
	set: (x: (s: PointsStore) => void) => void;
	get: (x: any) => PointsStore;
	zeroBasedAuthorityRank: number | null;
	oneBasedAuthorityRank: number | null;
	authorityScore: number | null;
	numOfParticipants: number | null;
	inProgressPointsDrop: {
		tradeVolume: number;
		isFetched: boolean;
	};
	leaderboard: {
		authority: string;
		points: number;
	}[];
	previousDropsAuthorityResults: {
		startTs: number;
		endTs: number;
		authorityScore: number | null;
		makerPoints: number | null;
		takerPoints: number | null;
		tradeVolume: number | null;
	}[];
	isFetched: boolean;
	nextPointsDrop: dayjs.Dayjs;

	updateNextPointsDrop: () => void;
	resetStore: () => void;
}

export const usePointsStore = create(
	devtools<PointsStore>((set, get) => {
		const setFn = (fn) => set(produce(fn));

		return {
			set: setFn,
			get: () => get(),
			zeroBasedAuthorityRank: null,
			oneBasedAuthorityRank: null,
			authorityScore: null,
			inProgressPointsDrop: {
				tradeVolume: 0,
				isFetched: false,
			},
			numOfParticipants: null,
			leaderboard: [],
			previousDropsAuthorityResults: [],
			isFetched: false,
			nextPointsDrop: getNextPointsDrop(),

			updateNextPointsDrop: () => {
				setFn((s) => {
					s.nextPointsDrop = getNextPointsDrop();
				});
			},
			resetStore: () => {
				setFn((s) => {
					s.zeroBasedAuthorityRank = null;
					s.oneBasedAuthorityRank = null;
					s.authorityScore = null;
					s.inProgressPointsDrop = {
						tradeVolume: 0,
						isFetched: false,
					};
					s.numOfParticipants = null;
					s.leaderboard = [];
					s.previousDropsAuthorityResults = [];
					s.isFetched = false;
				});
			},
		};
	})
);
